import apiService from '@/services/apiService';

const actions = {
  getCoverage({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.get(`paxel-recycle/coverage`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  postCoverage({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-recycle/coverage', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
